import React from 'react';
import { CTAButton } from './CTAButton';
export const ProductFeatures = () => {
  return <section id="features" className="w-full bg-white py-16 px-4 border-t border-gray-100" data-id="element-611">
      <div className="max-w-5xl mx-auto" data-id="element-612">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-teal-600 mb-6" data-id="element-613">
          What Makes Ardava Different
        </h2>
        <p className="text-center text-gray-700 text-lg max-w-3xl mx-auto mb-16" data-id="element-614">
          Ardava's revolutionary design & bamboo-blend technology lets you
          experience all-day comfort without constant readjustments
        </p>
        {/* Video demonstration section */}
        <div className="mb-16 bg-gray-50 rounded-xl p-8" data-id="element-615">
          <h3 className="text-2xl font-bold text-center text-teal-700 mb-6" data-id="element-616">
            See The Difference In Action
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-617">
            <div data-id="element-618">
              <div className="relative pt-[56.25%] rounded-lg overflow-hidden" data-id="element-619">
                <iframe src="https://player.vimeo.com/video/1115944242?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;loop=1&amp;muted=1" className="absolute top-0 left-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" title="kneeSleeveStretchingDemonstration" data-id="element-620"></iframe>
              </div>
            </div>
            <div data-id="element-621">
              <h4 className="text-xl font-semibold mb-4 text-teal-700" data-id="element-622">
                Perfect Stretch & Compression
              </h4>
              <p className="text-gray-700 mb-4" data-id="element-623">
                Watch how the Ardava knee sleeve provides the ideal balance of
                stretch and compression. The bamboo-blend fabric offers gentle
                support while maintaining flexibility for all-day comfort.
              </p>
              <ul className="space-y-3" data-id="element-624">
                <li className="flex items-start" data-id="element-625">
                  <svg className="w-5 h-5 text-teal-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-626">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-627" />
                  </svg>
                  <span className="text-gray-700" data-id="element-628">
                    360° gentle compression that moves with you
                  </span>
                </li>
                <li className="flex items-start" data-id="element-629">
                  <svg className="w-5 h-5 text-teal-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-630">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-631" />
                  </svg>
                  <span className="text-gray-700" data-id="element-632">
                    Tapered design prevents rolling or bunching
                  </span>
                </li>
                <li className="flex items-start" data-id="element-633">
                  <svg className="w-5 h-5 text-teal-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-634">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-635" />
                  </svg>
                  <span className="text-gray-700" data-id="element-636">
                    Maintains elasticity even after repeated washing
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-16" data-id="element-637">
          <div className="relative" data-id="element-638">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aCx64eFzXvFUawJyJRmFcd/upcloseWhicks.jpg" alt="Close-up of Ardava bamboo compression fabric" className="w-full h-80 object-cover rounded-lg shadow-md" data-id="element-639" />
            <div className="absolute -bottom-8 left-0 right-0 bg-white rounded-lg shadow-lg p-4 mx-4" data-id="element-640">
              <h3 className="font-semibold text-lg text-teal-700 mb-2 text-center" data-id="element-641">
                Breathable Bamboo-Blend Fabric
              </h3>
              <p className="text-gray-600 text-center text-sm" data-id="element-642">
                Keeps skin dry and comfortable all day long
              </p>
            </div>
          </div>
          <div className="relative" data-id="element-643">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mj9DveSUzXKY7CyD9hmWf3/image15.jpg" alt="Close-up of Ardava sleeve edge construction" className="w-full h-80 object-cover rounded-lg shadow-md" data-id="element-644" />
            <div className="absolute -bottom-8 left-0 right-0 bg-white rounded-lg shadow-lg p-4 mx-4" data-id="element-645">
              <h3 className="font-semibold text-lg text-teal-700 mb-2 text-center" data-id="element-646">
                Stay-Put Tapered Design
              </h3>
              <p className="text-gray-600 text-center text-sm" data-id="element-647">
                Flatlock seams and tapered cuff prevent rolling
              </p>
            </div>
          </div>
        </div>
        {/* Carol's video testimonial about wash comfort */}
        <div className="mb-16 bg-gray-50 rounded-xl p-8" data-id="element-648">
          <h3 className="text-2xl font-bold text-center text-teal-700 mb-6" data-id="element-649">
            Maintains Comfort After Washing
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-650">
            <div className="order-2 md:order-1" data-id="element-651">
              <h4 className="text-xl font-semibold mb-4 text-teal-700" data-id="element-652">
                Hear from Carol about wash durability
              </h4>
              <blockquote className="text-gray-700 italic mb-6" data-id="element-653">
                "I've washed my Ardava sleeve multiple times, and it's still as
                comfortable as the day I got it. Unlike other sleeves that lose
                their shape, this one maintains its perfect fit."
              </blockquote>
              <div className="flex items-center mb-4" data-id="element-654">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 mr-3 border border-teal-100" data-id="element-655">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wH244Um4LqrfSvTyuAKAjq/471161014_465996446529459_6565638794045668653_n.jpg" alt="Carol" className="w-full h-full object-cover" data-id="element-656" />
                </div>
                <div data-id="element-657">
                  <p className="font-medium" data-id="element-658">Carol W.</p>
                  <p className="text-sm text-gray-500" data-id="element-659">Verified Buyer</p>
                </div>
              </div>
              <p className="text-gray-700" data-id="element-660">
                The Ardava knee sleeve is designed to maintain its shape and
                compression through repeated washing, ensuring long-lasting
                comfort and support.
              </p>
            </div>
            <div className="order-1 md:order-2" data-id="element-661">
              <div className="relative pt-[56.25%] rounded-lg overflow-hidden" data-id="element-662">
                <iframe src="https://player.vimeo.com/video/1115944230?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;loop=1&amp;muted=1" className="absolute top-0 left-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" title="LadySayingHowSheLovesKneeSleeve" data-id="element-663"></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-664">
          <div className="bg-gray-50 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-665">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-666">
              <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-667">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-668" />
              </svg>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-gray-800" data-id="element-669">
              Gentle 360° Compression
            </h3>
            <p className="text-gray-600" data-id="element-670">
              Supports your body's natural sense of stability for a sure-footed
              feeling
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-671">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-672">
              <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-673">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" data-id="element-674" />
              </svg>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-gray-800" data-id="element-675">
              Ultra Breathable
            </h3>
            <p className="text-gray-600" data-id="element-676">
              No more hot, sweaty skin that makes sleeves slip and roll down
            </p>
          </div>
          <div className="bg-gray-50 rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-677">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-678">
              <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-679">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-680" />
              </svg>
            </div>
            <h3 className="font-semibold text-xl mb-3 text-gray-800" data-id="element-681">
              All-Day Durability
            </h3>
            <p className="text-gray-600" data-id="element-682">
              Maintains shape and gentle compression through repeated washes
            </p>
          </div>
        </div>
        <div className="bg-teal-50 rounded-xl p-8 mb-12" data-id="element-683">
          <h3 className="text-2xl font-bold text-center text-teal-700 mb-6" data-id="element-684">
            Technical Features Diagram
          </h3>
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-685">
            <div className="md:w-1/2 relative" data-id="element-686">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jhcLSe8U2ZKJMndeDxVEuT/woman_Jogging.webp" alt="Woman jogging with Ardava sleeve" className="w-full rounded-lg" data-id="element-687" />
              <div className="absolute top-1/4 right-0 flex items-center" data-id="element-688">
                <div className="bg-white rounded-full w-6 h-6 border-2 border-teal-500 flex-shrink-0" data-id="element-689"></div>
                <div className="h-0.5 w-16 bg-teal-500" data-id="element-690"></div>
                <div className="bg-white rounded-lg shadow-md p-2 text-xs" data-id="element-691">
                  <span className="font-medium text-teal-700" data-id="element-692">
                    Tapered cuff
                  </span>
                  <br data-id="element-693" />
                  spreads pressure evenly
                </div>
              </div>
              <div className="absolute top-1/2 left-0 flex items-center" data-id="element-694">
                <div className="bg-white rounded-lg shadow-md p-2 text-xs" data-id="element-695">
                  <span className="font-medium text-teal-700" data-id="element-696">
                    Micro-grip finish
                  </span>
                  <br data-id="element-697" />
                  prevents slipping
                </div>
                <div className="h-0.5 w-16 bg-teal-500" data-id="element-698"></div>
                <div className="bg-white rounded-full w-6 h-6 border-2 border-teal-500 flex-shrink-0" data-id="element-699"></div>
              </div>
              <div className="absolute bottom-1/4 right-0 flex items-center" data-id="element-700">
                <div className="bg-white rounded-full w-6 h-6 border-2 border-teal-500 flex-shrink-0" data-id="element-701"></div>
                <div className="h-0.5 w-16 bg-teal-500" data-id="element-702"></div>
                <div className="bg-white rounded-lg shadow-md p-2 text-xs" data-id="element-703">
                  <span className="font-medium text-teal-700" data-id="element-704">
                    Flatlock seams
                  </span>
                  <br data-id="element-705" />
                  prevent hot spots
                </div>
              </div>
            </div>
            <div className="md:w-1/2" data-id="element-706">
              <h4 className="text-xl font-semibold mb-4 text-teal-700" data-id="element-707">
                Stay-Put Comfort Design
              </h4>
              <ul className="space-y-4" data-id="element-708">
                <li className="flex items-start" data-id="element-709">
                  <span className="text-teal-600 font-bold mr-2 mt-1" data-id="element-710">•</span>
                  <span data-id="element-711">
                    <strong data-id="element-712">Breathable bamboo-blend knit</strong> keeps skin
                    comfortable (less slip-prone)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-713">
                  <span className="text-teal-600 font-bold mr-2 mt-1" data-id="element-714">•</span>
                  <span data-id="element-715">
                    <strong data-id="element-716">Wider, tapered top cuff</strong> spreads gentle
                    pressure to resist roll-down
                  </span>
                </li>
                <li className="flex items-start" data-id="element-717">
                  <span className="text-teal-600 font-bold mr-2 mt-1" data-id="element-718">•</span>
                  <span data-id="element-719">
                    <strong data-id="element-720">Discreet micro-grip finish</strong> adds stability
                    on stairs and longer walks
                  </span>
                </li>
                <li className="flex items-start" data-id="element-721">
                  <span className="text-teal-600 font-bold mr-2 mt-1" data-id="element-722">•</span>
                  <span data-id="element-723">
                    <strong data-id="element-724">Flatlock seams</strong> sit low against skin to
                    minimize hot spots
                  </span>
                </li>
              </ul>
              <div className="mt-6 bg-white p-4 rounded-lg shadow-sm" data-id="element-725">
                <blockquote className="italic text-gray-700 text-lg" data-id="element-726">
                  "I did a 3-mile walk and never touched it."
                </blockquote>
                <p className="text-sm text-gray-600 mt-2" data-id="element-727">— Verified Buyer</p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-728">
          <CTAButton text="Experience The Difference — 60-Day Guarantee" data-id="element-729" />
        </div>
      </div>
    </section>;
};